export default __webpack_public_path__ + "static/junk-removal-vs-dumpster-rental-86064ccb7403a6b8e5fdc06237981757.jpg";